import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import DiscountContext from '~/context/common/DiscountContext';
import { fetchDiscounts } from '~/services/common';
import { generateErrorLogger } from '~/utilities/loggers';

type OwnProps = {
  shouldFetch: boolean;
  stateAbbreviation: string;
  userId: string;
};

export default function useGetDiscountData({
  shouldFetch,
  stateAbbreviation,
  userId
}: OwnProps) {
  const {
    discounts: { setData, setError, setLoading }
  } = useContext(DiscountContext);

  useEffectWithController(
    controller => {
      if (!shouldFetch) return;

      setLoading();

      fetchDiscounts(stateAbbreviation, userId, controller)
        .then(res => setData(res.data.content?.discounts ?? []))
        .catch(
          generateErrorLogger(
            'Get discounts',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoading, shouldFetch, stateAbbreviation, userId]
  );
}
